class DeferredMedia extends HTMLElement {
  isPlaying = false;
  mediaPoster = null;
  toggleMediaButton = null;

  connectedCallback() {
    this.mediaPoster = this.querySelector('[data-ref="deferred-media-poster"]');
    this.toggleMediaButton = this.querySelector('[data-ref="toggle-media-button"]');

    this.mediaPoster?.addEventListener('click', this.showDeferredMedia.bind(this));
    this.toggleMediaButton?.addEventListener('click', this.toggleMedia.bind(this));
  }

  disconnectedCallback() {}

  updatePlayPauseHint(isPlaying) {
    if (this.toggleMediaButton instanceof HTMLElement) {
      this.toggleMediaButton.classList.remove('hidden');

      const playIcon = this.toggleMediaButton.querySelector('.icon-play');
      if (playIcon) playIcon.classList.toggle('hidden', isPlaying);

      const pauseIcon = this.toggleMediaButton.querySelector('.icon-pause');
      if (pauseIcon) pauseIcon.classList.toggle('hidden', !isPlaying);
    }
  }

  showDeferredMedia = () => {
    this.loadContent(true);
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  };

  loadContent(focus = true) {
    if (this.getAttribute('data-media-loaded')) return;

    const content = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);

    if (!content) return;

    this.setAttribute('data-media-loaded', 'true');

    this.querySelector('[data-ref="deferred-media-video"]')?.appendChild(content);

    // this.appendChild(content);

    if (focus && content instanceof HTMLElement) {
      content.focus();
    }

    // this.querySelector('[ref="deferred-media-poster"]')?.classList.add('deferred-media__playing');
    this.querySelector('[data-ref="deferred-media-poster"]')?.classList.add('deferred-media__playing');

    // if (content instanceof HTMLVideoElement && content.getAttribute('autoplay')) {
    //   // force autoplay for safari
    //   console.log("is true")
    //   content.play();
    // }
    if (content instanceof HTMLVideoElement) {
      window.registerVideos?.(this);
    }
  }

  toggleMedia() {
    if (this.isPlaying) {
      this.pauseMedia();
    } else {
      this.playMedia();
    }
  }

  playMedia() {
    /** @type {HTMLIFrameElement | null} */
    const iframe = this.querySelector('iframe[data-video-type]');
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === 'youtube'
          ? '{"event":"command","func":"playVideo","args":""}'
          : '{"method":"play"}',
        '*',
      );
    } else {
      this.querySelector('video')?.play();
    }
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }

  pauseMedia() {
    /** @type {HTMLIFrameElement | null} */
    const iframe = this.querySelector('iframe[data-video-type]');

    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === 'youtube'
          ? '{"event":"command","func":"' + 'pauseVideo' + '","args":""}'
          : '{"method":"pause"}',
        '*',
      );
    } else {
      this.querySelector('video')?.pause();
    }
    this.isPlaying = false;

    // If we've already revealed the deferred media, we should toggle the play/pause hint
    if (this.getAttribute('data-media-loaded')) {
      this.updatePlayPauseHint(this.isPlaying);
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}


let isALARenderedCategory;

function ALAcheckCatorgy() {
  clearInterval(isALARenderedCategory);

  if (document.body.classList.contains('template-product')) {
    isALARenderedCategory = setInterval(() => {
      const activeVideo = document.querySelector(
        ".splide__slide.is-active.is-visible video"
      );

      // console.log("video")

      if (!activeVideo) return;

      activeVideo.muted = true;
      activeVideo.defaultMuted = true;
      activeVideo.playsInline = true;
      activeVideo.autoplay = true;
      
      activeVideo.setAttribute("autoplay", "");
      activeVideo.setAttribute("muted", "");
      activeVideo.setAttribute("playsinline", "");
      activeVideo.setAttribute("webkit-playsinline", "");

      activeVideo.play().catch((error) => {
        console.log("Video autoplay blocked:", error);
      });

      clearInterval(isALARenderedCategory);
    }, 590);
  }
}

// ALAcheckCatorgy();




// Ak custom code
(function () {
  function kick(video) {
    if (!video) return;
    video.muted = true;
    video.playsInline = true;

    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        document.addEventListener(
          'touchstart',
          function () { video.play().catch(function () {}); },
          { once: true }
        );
      });
    }
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) kick(e.target);
        else e.target.pause();
      });
    },
    { threshold: 0.4 }
  );

  function registerVideos(root) {
    (root || document)
      .querySelectorAll('video.product-video')
      .forEach(function (v) {
        if (v.dataset.autoplayBound) return;
        v.dataset.autoplayBound = '1';
        io.observe(v);
      });
  }

  window.registerVideos = registerVideos;

  registerVideos();

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) registerVideos(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();



// document.querySelectorAll('video.product-video').forEach(v =>
//   console.log(v.currentSrc, v.readyState, v.paused, v.muted)
// );